import { createAction } from '../../../../store.model';
import { Chat } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface UpdateChat {
    chat: Chat;
}

export const updateChat = createAction<ActionType, UpdateChat>(
    ActionType.COACHING_DETAIL__TCD__UPDATE_CHAT,
);

export interface UpdateChatResult extends UpdateChat {}

export const updateChatResult = createAction<ActionType, UpdateChatResult>(
    ActionType.COACHING_DETAIL__TCD__UPDATE_CHAT_RESULT,
);
